import { useSelectedAccount } from '@ibk/shared-auth';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
import { BillingProductsSlugType } from '../../enums';
import { useLazyGetProductRelationShipsQuery } from '../../services/home/productApi';
export function useGetProductRelationShips() {
    const [trigger] = useLazyGetProductRelationShipsQuery();
    const { selectedAccount } = useSelectedAccount();
    const saveBillingProduct = async (targetIdInformed) => {
        try {
            const targetId = targetIdInformed ?? selectedAccount?.targetId;
            if (!targetId) {
                localStorageService.removeItem(StorageKeys.BillingProduct);
                localStorageService.removeItem(StorageKeys.BillingProductNFSe);
                localStorageService.removeItem(StorageKeys.BillingProductRegua);
                return;
            }
            const { data } = await trigger({ targetValue: targetId });
            if (!data) {
                localStorageService.removeItem(StorageKeys.BillingProduct);
                localStorageService.removeItem(StorageKeys.BillingProductNFSe);
                localStorageService.removeItem(StorageKeys.BillingProductRegua);
                return;
            }
            const product = data?.find(({ product }) => product.slug === BillingProductsSlugType.BILLING_MANAGEMENT);
            if (product) {
                localStorageService.setItemSync(StorageKeys.BillingProduct, product);
            }
            else {
                localStorageService.removeItem(StorageKeys.BillingProduct);
            }
            const productNFSe = data?.find(({ product }) => product.slug === BillingProductsSlugType.BILLING_MANAGEMENT_NFSE);
            if (productNFSe) {
                localStorageService.setItemSync(StorageKeys.BillingProductNFSe, productNFSe);
            }
            else {
                localStorageService.removeItem(StorageKeys.BillingProductNFSe);
            }
            const productRegua = data?.find(({ product }) => product.slug === BillingProductsSlugType.BILLING_MANAGEMENT_REGUA);
            if (productRegua) {
                localStorageService.setItemSync(StorageKeys.BillingProductRegua, productRegua);
            }
            else {
                localStorageService.removeItem(StorageKeys.BillingProductRegua);
            }
        }
        catch {
            localStorageService.removeItem(StorageKeys.BillingProduct);
            localStorageService.removeItem(StorageKeys.BillingProductNFSe);
            localStorageService.removeItem(StorageKeys.BillingProductRegua);
        }
    };
    const getBillingProduct = () => {
        const storedProduct = localStorageService.getItemSync(StorageKeys.BillingProduct);
        return storedProduct || null;
    };
    const getBillingProductNFSe = () => {
        const storedProduct = localStorageService.getItemSync(StorageKeys.BillingProductNFSe);
        return storedProduct || null;
    };
    const getBillingProductRegua = () => {
        const storedProduct = localStorageService.getItemSync(StorageKeys.BillingProductRegua);
        return storedProduct || null;
    };
    const hasNFSeAccess = () => {
        return !!getBillingProductNFSe();
    };
    const hasReguaAccess = () => {
        return !!getBillingProductRegua();
    };
    return {
        getBillingProduct,
        getBillingProductNFSe,
        getBillingProductRegua,
        hasNFSeAccess,
        hasReguaAccess,
        saveBillingProduct,
    };
}
